import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import { selectListing } from '../../selectors/listing';
import type { Facet, Facets } from '../interfaces/facets';

type FacetSelector = (
  state: SpartacuxProductDiscoveryDomainState,
) => Facet | undefined;

interface SelectFacet {
  (facet: string): FacetSelector;
}

export const selectCustomFacet: SelectFacet =
  (facet: string) => (state: SpartacuxProductDiscoveryDomainState) =>
    selectListing(state)?.customFacets?.[facet];

export const selectCustomFacets = (
  state: SpartacuxProductDiscoveryDomainState,
): Facets | undefined => selectListing(state)?.customFacets;
